import * as React from 'react';

import mediaQuery from '../../../helpers/mediaQuery';
import Image from '../../../components/image';

import DesktopMediaGallery from './components/DesktopMediaGallery';
import MobileMediaGallery from './components/MobileMediaGallery';

import useResizeListener from '../../../hooks/useResizeListener';

const { viewerMediaSet } = window.globalProductDetails;

function App(): React.ReactElement {
  const { innerWidth } = useResizeListener();
  const isMediumUp = React.useMemo(mediaQuery.isMediumUp, [innerWidth]);

  const noValidImages = !viewerMediaSet || viewerMediaSet.status === 'error' || !viewerMediaSet.items.length;
  if (noValidImages) {
    return (
      <div className="default-image">
        <Image src={`${window.bbGlobal.staticHost}/static/images/misc/pdp/loupe_image_coming_soon.jpg`} />
      </div>
    );
  }

  return isMediumUp ? <DesktopMediaGallery /> : <MobileMediaGallery />;
}

export default App;
